<script>
    import {Bubble} from 'vue-chartjs'
    import 'chartjs-plugin-zoom';
    import moment from 'moment-timezone';
    import constants from './const';
    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import LoadingModal from "@/components/modals/LoadingModal";
    //const ctx = document.getElementById('line-chart').getContext("2d");

    export default {
        extends: Bubble,
        props: {
            data: {
                type: Array,
                required: false
            },
            dragHandler: {
                type: Function,
                required: false
            },
            zoomLevel: {
                type: Number,
                required: false
            },
            enumNo: {
                type: Number,
                required: false
            },
            largeScreenBoolean: {
                type: Boolean,
                required: false
            },
            rendered: {
                type: Function,
                required: false
            }
        },
        data() {
            return {
                loading: false,
                zoomRange: null,
                options: {
                    animation: {
                        duration: 0
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            left: 5,
                            right: 5,
                            top: 30,
                            bottom: 0
                        }
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            afterFit: function (scaleInstance) {
                                scaleInstance.width = 150; // sets the width to 100px
                            },
                            ticks: {
                                fontColor: "#ffffff",
                                fontFamily: "Digital-Serial-Bold",
                                fontSize: 13,
                                lineHeight: 1,
                                padding: 10,
                                beginAtZero: true,
                                max: 5.6,
                                stepSize: 0.5,
                                callback: (value) => {
                                    // console.log(!this.selectedItemEnum ? 6 : constants.risk_group_array.filter(oneData => oneData.enum_no === this.selectedItemEnum)[0].sub_risks.length + 0.4);
                                    if (value % 1 === 0) {
                                        let sub_risk_array = constants.risk_group_array.filter(oneData => oneData.enum_no === this.enumNo)[0].sub_risks;
                                        let filteredArray = sub_risk_array.filter(oneSubRisk => oneSubRisk.graph_value === value);
                                        if (filteredArray.length) {
                                            return filteredArray[0].risk_name;
                                        }
                                    } else {
                                        return ""
                                    }
                                }
                            },
                            gridLines: {
                                color: this.getGridColors(),
                                lineWidth: 0.5,
                                drawTicks: true
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontColor: "#ffffff",
                                fontFamily: "Digital-Serial-Bold",
                                padding: 10,
                                stepSize: 1,
                                autoSkip: false,
                                maxRotation: 75,
                                minRotation: 75
                            },
                            position: 'top',
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    'millisecond': 'MM-DD-YY',
                                    'second': 'MM-DD-YY',
                                    'minute': 'MM-DD-YY',
                                    'hour': 'MM-DD-YY',
                                    'day': 'MM-DD-YY',
                                    'week': 'MM-DD-YY',
                                    'month': 'MM-DD-YY',
                                    'quarter': 'MM-DD-YY',
                                    'year': 'MM-DD-YY',
                                }
                            },
                            gridLines: {
                                display: false
                            },
                            afterUpdate: (evt) => {
                                let startDate = moment(evt.min);
                                let endDate = moment(evt.max);
                                this.$emit("dragHandler", startDate, endDate);
                            }
                        }]
                    },
                    tooltips: {
                        backgroundColor: "rgba(0,0,0,0)",
                        bodyFontColor: '#ffffff',
                        bodyFontSize: 12,
                        displayColors: false,
                        bodySpacing: 10,
                        bodyFontStyle: 'bold',
                        xPadding: 15,
                        yPadding: 10,
                        mode: 'nearest',
                        yAlign: 'bottom',
                        xAlign: 'center',
                        position: 'nearest',

                        callbacks: {
                            labelTextColor: function (tooltipItem, chart) {
                                return '#ffffff';
                            },
                            label: (tooltipItem, chart) => {
                                return chart.datasets[tooltipItem.datasetIndex].label + ' Threats on ' + moment(tooltipItem.xLabel).format('MM-DD-YY');
                            }
                        }
                    },
                    pan: {
                        enabled: true,
                        mode: "x",
                        speed: 10,
                        threshold: 10,
                    },
                    zoom: {
                        enabled: true,
                        drag: false,
                        mode: "",
                        limits: {
                            max: 10,
                            min: 0.5
                        }
                    }
                }
            }
        },
        computed: {
            chartData: function () {
                return this.data;
            },
            ...mapGetters([
                "getMaximizeZoomLevelIndex"
            ])
        },
        watch: {
            data: function () {
                this.$data._chart.destroy();
                this.renderBubbleChart();
                if (this.getMaximizeZoomLevelIndex >= 3) {
                    for (let i = 0; i < this.$data._chart.options.scales.xAxes.length; i++) {
                        this.$data._chart.options.scales.xAxes[i].time.unit = 'week';
                    }
                }
                else {
                    for (let i = 0; i < this.$data._chart.options.scales.xAxes.length; i++) {
                        this.$data._chart.options.scales.xAxes[i].time.unit = 'day';
                    }
                }
                this.$data._chart.options.scales.yAxes[0].ticks.max =
                    !this.enumNo ? 5.6 : constants.risk_group_array.filter(oneData => oneData.enum_no === this.enumNo)[0].sub_risks.length + 0.6;
                this.$data._chart.update();
            },
            largeScreenBoolean: function () {
                this.$data._chart.destroy();
                this.renderBubbleChart();
            }
        },
        methods: {
            getGridColors() {
                // console.log(this.enumNo);
                // console.log(constants.risk_group_array.filter(oneData => oneData.enum_no === this.enumNo)[0].sub_risks.length);
                let maxSubThreatCount = constants.risk_group_array.filter(oneData => oneData.enum_no === this.enumNo)[0].sub_risks.length;
                let tempArr = [];
                for (let i = 0; i < maxSubThreatCount + 1; i++) {
                    tempArr.push('rgba(255,255,255,0)');
                    tempArr.push('rgba(255,255,255,1)');
                }
                return tempArr;
            },
            renderBubbleChart() {
                this.renderChart({
                    datasets: this.chartData
                }, this.options)
                if (this.getMaximizeZoomLevelIndex >= 3) {
                    for (let i = 0; i < this.$data._chart.options.scales.xAxes.length; i++) {
                        this.$data._chart.options.scales.xAxes[i].time.unit = 'week';
                    }
                }
                else {
                    for (let i = 0; i < this.$data._chart.options.scales.xAxes.length; i++) {
                        this.$data._chart.options.scales.xAxes[i].time.unit = 'day';
                    }
                }
                this.$data._chart.options.scales.yAxes[0].ticks.max =
                    !this.enumNo ? 5.6 : constants.risk_group_array.filter(oneData => oneData.enum_no === this.enumNo)[0].sub_risks.length + 0.6;
                this.$data._chart.update();
                this.$emit("rendered", true);
            },
            setZoomStatus() {
                let zoomLevelIndex = this.getMaximizeZoomLevelIndex;
                if (zoomLevelIndex !== 2) {
                    zoomLevelIndex = 2;
                }
            },
            ...mapActions([
                "setMaximizeZoomLevelIndex"
            ])
        },
        mounted() {
            this.renderBubbleChart();
        },
        beforeMount() {
            this.setZoomStatus();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/threat-timeline/ThreatTimeLineMaximizeGraph.vue